// 쪽 그림 위에서 푸는 섹션(리더스북 전자책, 좌표가 실린 원서 세트)인가. 이 섹션은 바깥 머리줄을 걷고 화면 전체를
// 책에 준다. 노트북에서 머리줄 · 좁은 본문 폭 때문에 쪽이 너무 작았다(2026-10-18 대표). 나가기는 책 안에 있다.
export const isBookScreenSection = (section) =>
  Boolean(section) &&
  (section.type === "ebook" || (section.type === "book" && (section.question?.pages || []).length > 0));

